import NameValueView from "../../NameValueView.js";
const editors = new NameValueView('AttributeValueValidator', {
  handleKey: 'canValidate',
  multiple: true
});

/**
 * This function will return an AttributeValueEditor for the given attrName and objRef. The
 * returned object will contain { create }.
 * 
 * To register an AttributeValueEditor, add a plugin to the the type 'AttributeValueEditor'. The
 * object added should { createEditor( props ) }
 */

export default {
  getValidatorsFor: editors.getItemFor
};